<div class="product-detail-container">
  <!-- Versión Desktop -->
  <div class="desktop-view">
    <div class="product-detail-wrapper">
      <div class="product-detail-card">
        <div class="container-fluid">
          <div class="row product-main-row">
            <!-- Columna de Imagen y Etiquetas -->
            <div class="col-lg-5 product-image-column">
              <div class="title-section">
                <span class="product-category">{{
                  formatCategoryName(
                    (detalleLibro &&
                      detalleLibro.response &&
                      detalleLibro.response.list &&
                      detalleLibro.response.list[0] &&
                      detalleLibro.response.list[0].categoryName) ||
                      "Fotografía"
                  )
                }}</span>
                <span
                  class="product-subcategory"
                  *ngIf="
                    detalleLibro &&
                    detalleLibro.response &&
                    detalleLibro.response.list &&
                    detalleLibro.response.list[0] &&
                    detalleLibro.response.list[0].subCategoryName
                  "
                  >{{
                    formatCategoryName(
                      detalleLibro.response.list[0].subCategoryName
                    )
                  }}</span
                >
                <h1 class="product-title">
                  {{
                    detalleLibro &&
                      detalleLibro.response &&
                      detalleLibro.response.list &&
                      detalleLibro.response.list[0] &&
                      detalleLibro.response.list[0].title
                  }}
                </h1>
                <div class="product-meta">
                  <span
                    class="product-date"
                    *ngIf="
                      detalleLibro &&
                      detalleLibro.response &&
                      detalleLibro.response.list &&
                      detalleLibro.response.list[0] &&
                      (getMetadataDate(
                        detalleLibro.response.list[0].activoId
                      ) ||
                        detalleLibro.response.list[0].fechaPublicacion ||
                        detalleLibro.response.list[0].fechaCreation ||
                        detalleLibro.response.list[0].yearName)
                    "
                  >
                    <i class="fas fa-calendar-alt"></i>
                    {{
                      getMetadataDate(detalleLibro.response.list[0].activoId) ||
                        detalleLibro.response.list[0].fechaPublicacion ||
                        detalleLibro.response.list[0].fechaCreation ||
                        detalleLibro.response.list[0].yearName
                    }}
                  </span>
                  <span class="product-id">
                    <i class="fas fa-hashtag"></i>
                    ID:
                    {{
                      detalleLibro &&
                        detalleLibro.response &&
                        detalleLibro.response.list &&
                        detalleLibro.response.list[0] &&
                        detalleLibro.response.list[0].id
                    }}
                  </span>
                </div>
              </div>
              <!-- Imagen - Mitad superior -->
              <div class="image-container">
                <ng-container
                  *ngIf="
                    !shouldShowSkeleton(
                      detalleLibro &&
                        detalleLibro.response &&
                        detalleLibro.response.list &&
                        detalleLibro.response.list[0] &&
                        detalleLibro.response.list[0].activoId
                    )
                  "
                >
                  <app-image-zoom
                    *ngIf="
                      getProtectedImageUrl(
                        detalleLibro &&
                          detalleLibro.response &&
                          detalleLibro.response.list &&
                          detalleLibro.response.list[0] &&
                          detalleLibro.response.list[0].activoId
                      )
                    "
                    [class]="getImageOrientationClass()"
                    [imageUrl]="
                      getProtectedImageUrl(
                        detalleLibro &&
                          detalleLibro.response &&
                          detalleLibro.response.list &&
                          detalleLibro.response.list[0] &&
                          detalleLibro.response.list[0].activoId
                      )
                    "
                    [magnifiedImageUrl]="
                      getProtectedPreviewImageUrl(
                        detalleLibro &&
                          detalleLibro.response &&
                          detalleLibro.response.list &&
                          detalleLibro.response.list[0] &&
                          detalleLibro.response.list[0].activoId
                      )
                    "
                    [imageAlt]="
                      detalleLibro &&
                      detalleLibro.response &&
                      detalleLibro.response.list &&
                      detalleLibro.response.list[0] &&
                      detalleLibro.response.list[0].title
                    "
                    [originalWidth]="
                      detalleLibro &&
                      detalleLibro.response &&
                      detalleLibro.response.list &&
                      detalleLibro.response.list[0] &&
                      detalleLibro.response.list[0].width
                        ? parseInt(detalleLibro.response.list[0].width)
                        : 0
                    "
                    [originalHeight]="
                      detalleLibro &&
                      detalleLibro.response &&
                      detalleLibro.response.list &&
                      detalleLibro.response.list[0] &&
                      detalleLibro.response.list[0].height
                        ? parseInt(detalleLibro.response.list[0].height)
                        : 0
                    "
                  >
                  </app-image-zoom>
                </ng-container>

                <app-image-skeleton
                  *ngIf="
                    shouldShowSkeleton(
                      detalleLibro &&
                        detalleLibro.response &&
                        detalleLibro.response.list &&
                        detalleLibro.response.list[0] &&
                        detalleLibro.response.list[0].activoId
                    )
                  "
                  [width]="getSkeletonDimensions().width"
                  [height]="getSkeletonDimensions().height"
                  size="medium"
                >
                </app-image-skeleton>

                <p class="imagen-calidad-nota">
                  <i class="fas fa-info-circle"></i>
                  La imagen mostrada es de calidad reducida. Al adquirir este
                  producto, recibirá la imagen en alta resolución.
                </p>
              </div>

              <!-- Etiquetas - Mitad inferior -->
              <div class="tags-section-sidebar">
                <!-- Modalidad, Precio y Botones Mobile Only -->
                <div
                  class="mobile-purchase-section"
                  *ngIf="
                    detalleLibro &&
                    detalleLibro.response &&
                    detalleLibro.response.list &&
                    detalleLibro.response.list[0]
                  "
                >
                  <!-- Modalidad de Uso Mobile -->
                  <div class="usage-mode-section-mobile">
                    <div class="section-header-mobile">
                      <div class="title-part-mobile">
                        <i class="fas fa-layer-group"></i>
                        <h3>Modalidad de uso(*)</h3>
                      </div>
                    </div>
                    <div class="mode-buttons-mobile">
                      <button
                        *ngFor="let modalidad of listModalidad"
                        [title]="getTitleForModalidad(modalidad)"
                        class="mode-btn"
                        [class.active]="modalidadCss(modalidad) === 'active'"
                        (click)="cambiarModalidad(modalidad)"
                      >
                        <span class="mode-text">{{
                          getModalidadDisplayName(modalidad)
                        }}</span>
                      </button>
                    </div>
                    <div class="usage-note-mobile">
                      <p>
                        (*) Para más información sobre las modalidades de uso,
                        consulte nuestros
                        <a
                          href="terminos-condiciones"
                          target="_blank"
                          class="terminos-link"
                          >términos y condiciones</a
                        >.
                      </p>
                    </div>
                  </div>

                  <!-- Stock Alert Mobile -->
                  <div
                    class="stock-alert-mobile"
                    *ngIf="parseInt(detalleLibro.response.list[0].stock) === 0"
                  >
                    <i class="fas fa-exclamation-circle"></i>
                    <span>Producto sin Stock</span>
                  </div>

                  <!-- Precio y Botones en la misma fila -->
                  <div
                    class="price-actions-row-mobile"
                    *ngIf="parseInt(detalleLibro.response.list[0].stock) > 0"
                  >
                    <!-- Precio Mobile -->
                    <div class="price-section-mobile">
                      <div class="price-content-mobile">
                        <span class="product-price-mobile"
                          >{{ currencyActiva }} {{ precioTotalFormat }}</span
                        >
                        <span class="tax-badge-mobile"
                          >Impuestos incluidos</span
                        >
                      </div>
                    </div>

                    <!-- Botones de Acción Mobile -->
                    <div class="action-buttons-mobile">
                      <button
                        class="btn btn-add-to-cart"
                        (click)="agregarCarrito()"
                      >
                        <i class="fas fa-shopping-cart"></i>
                        <span>Agregar al Carrito</span>
                      </button>
                      <button class="btn btn-buy-now" (click)="onComprar()">
                        <i class="fas fa-bolt"></i>
                        <span>Comprar Ahora</span>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="ocultar-mobile">
                  <div class="section-header">
                    <div class="title-part">
                      <i class="fas fa-tags"></i>
                      <h3>Etiquetas relacionadas</h3>
                    </div>
                    <div class="tags-container-sidebar">
                      <span
                        *ngFor="let tag of tagPublicacion"
                        class="tag-sidebar"
                        (click)="prueba(tag)"
                      >
                        {{ tag }}
                      </span>
                    </div>
                  </div>

                  <!-- Botones de compartir -->
                  <div class="social-sharing-sidebar">
                    <div class="section-header">
                      <div class="title-part">
                        <i class="fas fa-share-alt"></i>
                        <h3>Compartir</h3>
                      </div>
                      <div class="social-buttons-sidebar">
                        <button
                          class="social-btn facebook"
                          (click)="sharedFacebook()"
                        >
                          <img
                            src="/assets/image/compartir-f.png"
                            alt="Facebook"
                            class="social-icon"
                          />
                        </button>
                        <button
                          class="social-btn whatsapp"
                          (click)="sharedWhatsapp()"
                        >
                          <img
                            src="/assets/image/compartir-w.png"
                            alt="WhatsApp"
                            class="social-icon"
                          />
                        </button>
                        <button
                          class="social-btn twitter"
                          (click)="sharedTwitter()"
                        >
                          <img
                            src="/assets/image/compartir-x.png"
                            alt="X"
                            class="social-icon"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Columna de Información -->
            <div class="col-lg-7 product-info-column">
              <div class="product-content">
                <!-- Header con Precio -->
                <div class="product-header">
                  <div class="spacer"></div>
                  <div class="price-section-right">
                    <div
                      *ngIf="
                        parseInt(
                          detalleLibro &&
                            detalleLibro.response &&
                            detalleLibro.response.list &&
                            detalleLibro.response.list[0] &&
                            detalleLibro.response.list[0].stock
                        ) === 0
                      "
                      class="stock-alert"
                    >
                      <i class="fas fa-exclamation-circle"></i>
                      <span>Producto sin Stock</span>
                    </div>

                    <div
                      *ngIf="
                        parseInt(
                          detalleLibro &&
                            detalleLibro.response &&
                            detalleLibro.response.list &&
                            detalleLibro.response.list[0] &&
                            detalleLibro.response.list[0].stock
                        ) > 0
                      "
                      class="price-content"
                    >
                      <div class="price-main">
                        <span class="product-price"
                          >{{ currencyActiva }} {{ precioTotalFormat }}</span
                        >
                        <span class="tax-badge">Impuestos incluidos</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Descripción -->
                <div class="product-description-section">
                  <div class="section-header">
                    <i class="fas fa-align-left"></i>
                    <h3>Descripción</h3>
                  </div>
                  <div class="product-description">
                    <p>
                      {{
                        detalleLibro &&
                          detalleLibro.response &&
                          detalleLibro.response.list &&
                          detalleLibro.response.list[0] &&
                          detalleLibro.response.list[0].description
                      }}
                    </p>
                  </div>
                </div>

                <!-- Información Técnica -->
                <div class="technical-specs">
                  <div class="section-header">
                    <i class="fa fa-list-ul"></i>
                    <h3>Especificaciones técnicas</h3>
                  </div>
                  <div class="specs-grid">
                    <div
                      class="spec-item"
                      *ngIf="
                        detalleLibro &&
                        detalleLibro.response &&
                        detalleLibro.response.list &&
                        detalleLibro.response.list[0] &&
                        detalleLibro.response.list[0].authorName
                      "
                    >
                      <label class="spec-label">Autor</label>
                      <div class="spec-body">
                        <div class="spec-icon">
                          <i class="fas fa-user"></i>
                        </div>
                        <span class="spec-value">{{
                          detalleLibro.response.list[0].authorName
                        }}</span>
                      </div>
                    </div>

                    <div
                      class="spec-item"
                      *ngIf="
                        detalleLibro &&
                        detalleLibro.response &&
                        detalleLibro.response.list &&
                        detalleLibro.response.list[0] &&
                        detalleLibro.response.list[0].diarioName
                      "
                    >
                      <label class="spec-label">Publicación</label>
                      <div class="spec-body">
                        <div class="spec-icon">
                          <i class="fas fa-newspaper"></i>
                        </div>
                        <span class="spec-value">{{
                          detalleLibro.response.list[0].diarioName
                        }}</span>
                      </div>
                    </div>

                    <div
                      class="spec-item"
                      *ngIf="
                        detalleLibro &&
                        detalleLibro.response &&
                        detalleLibro.response.list &&
                        detalleLibro.response.list[0] &&
                        detalleLibro.response.list[0].yearName
                      "
                    >
                      <label class="spec-label">Año</label>
                      <div class="spec-body">
                        <div class="spec-icon">
                          <i class="fas fa-calendar-alt"></i>
                        </div>
                        <span class="spec-value">{{
                          getMetadataDate(
                            detalleLibro.response.list[0].activoId
                          ) ||
                            detalleLibro.response.list[0].fechaPublicacion ||
                            detalleLibro.response.list[0].yearName
                        }}</span>
                      </div>
                    </div>

                    <div class="spec-item">
                      <label class="spec-label">Dimensiones</label>
                      <div class="spec-body">
                        <div class="spec-icon">
                          <i class="fas fa-ruler-combined"></i>
                        </div>
                        <span class="spec-value"
                          >{{
                            detalleLibro &&
                              detalleLibro.response &&
                              detalleLibro.response.list &&
                              detalleLibro.response.list[0] &&
                              detalleLibro.response.list[0].width
                          }}
                          ×
                          {{
                            detalleLibro &&
                              detalleLibro.response &&
                              detalleLibro.response.list &&
                              detalleLibro.response.list[0] &&
                              detalleLibro.response.list[0].height
                          }}
                          px</span
                        >
                      </div>
                    </div>

                    <div class="spec-item">
                      <label class="spec-label">Formato</label>
                      <div class="spec-body">
                        <div class="spec-icon">
                          <i class="fas fa-file-image"></i>
                        </div>
                        <span class="spec-value">300 dpi</span>
                      </div>
                    </div>

                    <div
                      class="spec-item"
                      *ngIf="
                        detalleLibro &&
                        detalleLibro.response &&
                        detalleLibro.response.list &&
                        detalleLibro.response.list[0] &&
                        detalleLibro.response.list[0].measure
                      "
                    >
                      <label class="spec-label">Medidas</label>
                      <div class="spec-body">
                        <div class="spec-icon">
                          <i class="fas fa-expand"></i>
                        </div>
                        <span class="spec-value">{{
                          detalleLibro.response.list[0].measure
                        }}</span>
                      </div>
                    </div>

                    <div
                      class="spec-item"
                      *ngIf="
                        detalleLibro &&
                        detalleLibro.response &&
                        detalleLibro.response.list &&
                        detalleLibro.response.list[0] &&
                        detalleLibro.response.list[0].fechaPublicacion
                      "
                    >
                      <label class="spec-label">{{ getFechaLabel() }}</label>

                      <div class="spec-body">
                        <div class="spec-icon">
                          <i class="fas fa-calendar-day"></i>
                        </div>
                        <span class="spec-value">{{
                          detalleLibro.response.list[0].fechaPublicacion
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Modalidad de Uso -->
                <div class="usage-mode-section">
                  <div class="section-header">
                    <div class="title-part">
                      <i class="fas fa-layer-group"></i>
                      <h3>Modalidad de uso(*)</h3>
                    </div>
                    <div class="mode-buttons">
                      <button
                        *ngFor="let modalidad of listModalidad"
                        [title]="getTitleForModalidad(modalidad)"
                        class="mode-btn"
                        [class.active]="modalidadCss(modalidad) === 'active'"
                        (click)="cambiarModalidad(modalidad)"
                      >
                        <span class="mode-text">{{
                          getModalidadDisplayName(modalidad)
                        }}</span>
                        <span class="mode-tooltip">{{
                          getTitleForModalidad(modalidad)
                        }}</span>
                      </button>
                    </div>
                  </div>
                  <div class="usage-note">
                    <p>
                      (*) Para más información sobre las modalidades de uso,
                      consulte nuestros
                      <a
                        href="terminos-condiciones"
                        target="_blank"
                        class="terminos-link"
                        >términos y condiciones</a
                      >.
                    </p>
                  </div>
                </div>

                <!-- Botones de Acción -->
                <div class="action-buttons">
                  <button
                    *ngIf="
                      parseInt(
                        detalleLibro &&
                          detalleLibro.response &&
                          detalleLibro.response.list &&
                          detalleLibro.response.list[0] &&
                          detalleLibro.response.list[0].stock
                      ) > 0
                    "
                    class="btn btn-add-to-cart"
                    (click)="agregarCarrito()"
                  >
                    <i class="fas fa-shopping-cart"></i>
                    <span>Agregar al Carrito</span>
                    <div class="btn-hover-effect"></div>
                  </button>
                  <button
                    *ngIf="
                      parseInt(
                        detalleLibro &&
                          detalleLibro.response &&
                          detalleLibro.response.list &&
                          detalleLibro.response.list[0] &&
                          detalleLibro.response.list[0].stock
                      ) > 0
                    "
                    class="btn btn-buy-now"
                    (click)="onComprar()"
                  >
                    <i class="fas fa-bolt"></i>
                    <span>Comprar Ahora</span>
                    <div class="btn-hover-effect"></div>
                  </button>
                </div>

                <div class="mostrar-mobile">
                  <div class="tags-section-mobile">
                    <div class="section-header-mobile">
                      <div class="title-part-mobile">
                        <i class="fas fa-tags"></i>
                        <h3>Etiquetas relacionadas</h3>
                      </div>
                    </div>
                    <div class="tags-container-sidebar">
                      <span
                        *ngFor="let tag of tagPublicacion"
                        class="tag-sidebar"
                        (click)="prueba(tag)"
                      >
                        {{ tag }}
                      </span>
                    </div>
                  </div>

                  <!-- Botones de compartir -->
                  <div class="social-sharing-mobile">
                    <div class="section-header-mobile">
                      <div class="title-part-mobile">
                        <i class="fas fa-share-alt"></i>
                        <h3>Compartir</h3>
                      </div>
                    </div>
                    <div class="social-buttons-sidebar">
                      <button
                        class="social-btn facebook"
                        (click)="sharedFacebook()"
                      >
                        <img
                          src="/assets/image/compartir-f.png"
                          alt="Facebook"
                          class="social-icon"
                        />
                      </button>
                      <button
                        class="social-btn whatsapp"
                        (click)="sharedWhatsapp()"
                      >
                        <img
                          src="/assets/image/compartir-w.png"
                          alt="WhatsApp"
                          class="social-icon"
                        />
                      </button>
                      <button
                        class="social-btn twitter"
                        (click)="sharedTwitter()"
                      >
                        <img
                          src="/assets/image/compartir-x.png"
                          alt="X"
                          class="social-icon"
                        />
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Información de Seguridad de Pago -->
                <div class="payment-security-inline">
                  <div class="security-badge-inline">
                    <i class="fas fa-lock"></i>
                    <div class="security-text-inline">
                      <strong>Pago 100% seguro</strong>
                      <span>Protegido por encriptación SSL</span>
                    </div>
                  </div>
                  <div class="payment-methods-inline">
                    <img src="/assets/image/tarjeta-visa.png" alt="Visa" />
                    <img
                      src="/assets/image/tarjeta-mastercard.png"
                      alt="Mastercard"
                    />
                    <img
                      src="/assets/image/tarjeta-american.png"
                      alt="American Express"
                    />
                    <img
                      src="/assets/image/tarjeta-diners.png"
                      alt="Diners Club"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Versión Móvil -->
  <div
    class="mobile-view"
    *ngIf="
      detalleLibro &&
      detalleLibro.response &&
      detalleLibro.response.list &&
      detalleLibro.response.list[0]
    "
  >
    <!-- 1. Título de la fotografía -->
    <div class="title-section">
      <span class="product-category">{{
        formatCategoryName(
          detalleLibro.response.list[0].categoryName || "Fotografía"
        )
      }}</span>
      <span
        class="product-subcategory"
        *ngIf="detalleLibro.response.list[0].subCategoryName"
        >{{
          formatCategoryName(detalleLibro.response.list[0].subCategoryName)
        }}</span
      >
      <h1 class="product-title">
        {{ detalleLibro.response.list[0].title }}
      </h1>

      <!-- 2. Año | ID -->
      <div class="product-meta">
        <span
          class="product-date"
          *ngIf="
            getMetadataDate(detalleLibro.response.list[0].activoId) ||
            detalleLibro.response.list[0].fechaPublicacion ||
            detalleLibro.response.list[0].fechaCreation ||
            detalleLibro.response.list[0].yearName
          "
        >
          <i class="fas fa-calendar-alt"></i>
          {{
            getMetadataDate(detalleLibro.response.list[0].activoId) ||
              detalleLibro.response.list[0].fechaPublicacion ||
              detalleLibro.response.list[0].fechaCreation ||
              detalleLibro.response.list[0].yearName
          }}
        </span>
        <span class="product-id">
          <i class="fas fa-hashtag"></i>
          ID: {{ detalleLibro.response.list[0].id }}
        </span>
      </div>
    </div>

    <!-- 3. Foto + Advertencia -->
    <div class="image-container">
      <ng-container
        *ngIf="!shouldShowSkeleton(detalleLibro.response.list[0].activoId)"
      >
        <app-image-zoom
          *ngIf="getProtectedImageUrl(detalleLibro.response.list[0].activoId)"
          [class]="getImageOrientationClass()"
          [imageUrl]="
            getProtectedImageUrl(detalleLibro.response.list[0].activoId)
          "
          [magnifiedImageUrl]="
            getProtectedPreviewImageUrl(detalleLibro.response.list[0].activoId)
          "
          [imageAlt]="detalleLibro.response.list[0].title"
          [originalWidth]="
            detalleLibro.response.list[0].width
              ? parseInt(detalleLibro.response.list[0].width)
              : 0
          "
          [originalHeight]="
            detalleLibro.response.list[0].height
              ? parseInt(detalleLibro.response.list[0].height)
              : 0
          "
        >
        </app-image-zoom>
      </ng-container>

      <app-image-skeleton
        *ngIf="shouldShowSkeleton(detalleLibro.response.list[0].activoId)"
        [width]="getSkeletonDimensions().width"
        [height]="getSkeletonDimensions().height"
        size="medium"
      >
      </app-image-skeleton>

      <p class="imagen-calidad-nota">
        <i class="fas fa-info-circle"></i>
        La imagen mostrada es de calidad reducida. Al adquirir este producto,
        recibirá la imagen en alta resolución.
      </p>
    </div>

    <!-- 4. Modalidad de uso -->
    <div class="usage-mode-section-mobile">
      <div class="section-header-mobile">
        <div class="title-part-mobile">
          <i class="fas fa-layer-group"></i>
          <h3>Modalidad de uso(*)</h3>
        </div>
      </div>
      <div class="mode-buttons-mobile">
        <button
          *ngFor="let modalidad of listModalidad"
          [title]="getTitleForModalidad(modalidad)"
          class="mode-btn"
          [class.active]="modalidadCss(modalidad) === 'active'"
          (click)="cambiarModalidad(modalidad)"
        >
          <span class="mode-text">{{
            getModalidadDisplayName(modalidad)
          }}</span>
        </button>
      </div>
      <div class="usage-note-mobile">
        <p>
          (*) Para más información sobre las modalidades de uso, consulte
          nuestros
          <a href="terminos-condiciones" target="_blank" class="terminos-link"
            >términos y condiciones</a
          >.
        </p>
      </div>
    </div>

    <!-- 5. Precio + botones -->
    <!-- Stock Alert Mobile -->
    <div
      class="stock-alert-mobile"
      *ngIf="parseInt(detalleLibro.response.list[0].stock) === 0"
    >
      <i class="fas fa-exclamation-circle"></i>
      <span>Producto sin Stock</span>
    </div>

    <!-- Precio y Botones -->
    <div
      class="price-actions-row-mobile"
      *ngIf="parseInt(detalleLibro.response.list[0].stock) > 0"
    >
      <!-- Precio Mobile -->
      <div class="price-section-mobile">
        <div class="price-content-mobile">
          <span class="product-price-mobile"
            >{{ currencyActiva }} {{ precioTotalFormat }}</span
          >
          <span class="tax-badge-mobile">Impuestos incluidos</span>
        </div>
      </div>

      <!-- Botones de Acción Mobile -->
      <div class="action-buttons-mobile">
        <button class="btn btn-add-to-cart" (click)="agregarCarrito()">
          <i class="fas fa-shopping-cart"></i>
          <span>Agregar al Carrito</span>
        </button>
        <button class="btn btn-buy-now" (click)="onComprar()">
          <i class="fas fa-bolt"></i>
          <span>Comprar Ahora</span>
        </button>
      </div>
    </div>

    <!-- 6. Descripción -->
    <div class="product-description-section">
      <div class="section-header">
        <i class="fas fa-align-left"></i>
        <h3>Descripción</h3>
      </div>
      <div class="product-description">
        <p>{{ detalleLibro.response.list[0].description }}</p>
      </div>
    </div>

    <!-- 7. Especificaciones técnicas -->
    <div class="technical-specs">
      <div class="section-header">
        <i class="fa fa-list-ul"></i>
        <h3>Especificaciones técnicas</h3>
      </div>
      <div class="specs-grid">
        <div class="spec-item" *ngIf="detalleLibro.response.list[0].authorName">
          <label class="spec-label">Autor</label>
          <div class="spec-body">
            <div class="spec-icon">
              <i class="fas fa-user"></i>
            </div>
            <span class="spec-value">{{
              detalleLibro.response.list[0].authorName
            }}</span>
          </div>
        </div>

        <div class="spec-item" *ngIf="detalleLibro.response.list[0].diarioName">
          <label class="spec-label">Publicación</label>
          <div class="spec-body">
            <div class="spec-icon">
              <i class="fas fa-newspaper"></i>
            </div>
            <span class="spec-value">{{
              detalleLibro.response.list[0].diarioName
            }}</span>
          </div>
        </div>

        <div class="spec-item" *ngIf="detalleLibro.response.list[0].yearName">
          <label class="spec-label">Año</label>
          <div class="spec-body">
            <div class="spec-icon">
              <i class="fas fa-calendar-alt"></i>
            </div>
            <span class="spec-value">{{
              getMetadataDate(detalleLibro.response.list[0].activoId) ||
                detalleLibro.response.list[0].fechaPublicacion ||
                detalleLibro.response.list[0].yearName
            }}</span>
          </div>
        </div>

        <div class="spec-item">
          <label class="spec-label">Dimensiones</label>
          <div class="spec-body">
            <div class="spec-icon">
              <i class="fas fa-ruler-combined"></i>
            </div>
            <span class="spec-value"
              >{{ detalleLibro.response.list[0].width }} ×
              {{ detalleLibro.response.list[0].height }} px</span
            >
          </div>
        </div>

        <div class="spec-item">
          <label class="spec-label">Formato</label>
          <div class="spec-body">
            <div class="spec-icon">
              <i class="fas fa-file-image"></i>
            </div>
            <span class="spec-value">300 dpi</span>
          </div>
        </div>

        <div class="spec-item" *ngIf="detalleLibro.response.list[0].measure">
          <label class="spec-label">Medidas</label>
          <div class="spec-body">
            <div class="spec-icon">
              <i class="fas fa-expand"></i>
            </div>
            <span class="spec-value">{{
              detalleLibro.response.list[0].measure
            }}</span>
          </div>
        </div>

        <div
          class="spec-item"
          *ngIf="detalleLibro.response.list[0].fechaPublicacion"
        >
          <label class="spec-label">{{ getFechaLabel() }}</label>
          <div class="spec-body">
            <div class="spec-icon">
              <i class="fas fa-calendar-day"></i>
            </div>
            <span class="spec-value">{{
              detalleLibro.response.list[0].fechaPublicacion
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 8. Etiquetas relacionadas -->
    <div class="tags-section-mobile">
      <div class="section-header-mobile">
        <div class="title-part-mobile">
          <i class="fas fa-tags"></i>
          <h3>Etiquetas relacionadas</h3>
        </div>
      </div>
      <div class="tags-container-sidebar">
        <span
          *ngFor="let tag of tagPublicacion"
          class="tag-sidebar"
          (click)="prueba(tag)"
        >
          {{ tag }}
        </span>
      </div>
    </div>

    <!-- Botones de compartir -->
    <div class="social-sharing-mobile">
      <div class="section-header-mobile">
        <div class="title-part-mobile">
          <i class="fas fa-share-alt"></i>
          <h3>Compartir</h3>
        </div>
      </div>
      <div class="social-buttons-sidebar">
        <button class="social-btn facebook" (click)="sharedFacebook()">
          <img
            src="/assets/image/compartir-f.png"
            alt="Facebook"
            class="social-icon"
          />
        </button>
        <button class="social-btn whatsapp" (click)="sharedWhatsapp()">
          <img
            src="/assets/image/compartir-w.png"
            alt="WhatsApp"
            class="social-icon"
          />
        </button>
        <button class="social-btn twitter" (click)="sharedTwitter()">
          <img
            src="/assets/image/compartir-x.png"
            alt="X"
            class="social-icon"
          />
        </button>
      </div>
    </div>

    <!-- Información de Seguridad de Pago -->
    <div class="payment-security-inline">
      <div class="security-badge-inline">
        <i class="fas fa-lock"></i>
        <div class="security-text-inline">
          <strong>Pago 100% seguro</strong>
          <span>Protegido por encriptación SSL</span>
        </div>
      </div>
      <div class="payment-methods-inline">
        <img src="/assets/image/tarjeta-visa.png" alt="Visa" />
        <img src="/assets/image/tarjeta-mastercard.png" alt="Mastercard" />
        <img src="/assets/image/tarjeta-american.png" alt="American Express" />
        <img src="/assets/image/tarjeta-diners.png" alt="Diners Club" />
      </div>
    </div>
  </div>

  <!-- Botones Flotantes Sticky para Móvil -->
  <div
    class="sticky-action-buttons"
    *ngIf="
      showStickyButtons &&
      detalleLibro &&
      detalleLibro.response &&
      detalleLibro.response.list &&
      detalleLibro.response.list[0] &&
      parseInt(detalleLibro.response.list[0].stock) > 0
    "
  >
    <!-- Botón Carrito con menú desplegable -->
    <div class="sticky-btn-wrapper">
      <button
        class="sticky-btn sticky-btn-cart"
        (click)="toggleModalidadMenuCart($event)"
      >
        <i class="fas fa-shopping-cart"></i>
        <span>Carrito</span>
        <i
          class="fas fa-chevron-up"
          *ngIf="listModalidad && listModalidad.length > 1"
        ></i>
      </button>

      <!-- Menú desplegable de modalidades para Carrito -->
      <div
        class="modalidad-dropdown"
        *ngIf="
          showModalidadMenuCart && listModalidad && listModalidad.length > 1
        "
      >
        <div class="modalidad-dropdown-header">
          <i class="fas fa-layer-group"></i>
          <span>Seleccionar modalidad</span>
        </div>
        <button
          *ngFor="let modalidad of listModalidad"
          class="modalidad-dropdown-item"
          [class.active]="modalidadCss(modalidad) === 'active'"
          (click)="selectModalidadAndAddToCart(modalidad)"
        >
          <div class="modalidad-info">
            <span class="modalidad-name">{{
              getTitleForModalidad(modalidad)
            }}</span>
            <span class="modalidad-price">{{
              getModalidadPrice(modalidad)
            }}</span>
          </div>
          <span class="modalidad-code">{{ modalidad }}</span>
        </button>
      </div>
    </div>

    <!-- Botón Comprar con menú desplegable -->
    <div class="sticky-btn-wrapper">
      <button
        class="sticky-btn sticky-btn-buy"
        (click)="toggleModalidadMenuBuy($event)"
      >
        <i class="fas fa-bolt"></i>
        <span>Comprar</span>
        <i
          class="fas fa-chevron-up"
          *ngIf="listModalidad && listModalidad.length > 1"
        ></i>
      </button>

      <!-- Menú desplegable de modalidades para Comprar -->
      <div
        class="modalidad-dropdown"
        *ngIf="
          showModalidadMenuBuy && listModalidad && listModalidad.length > 1
        "
      >
        <div class="modalidad-dropdown-header">
          <i class="fas fa-layer-group"></i>
          <span>Seleccionar modalidad</span>
        </div>
        <button
          *ngFor="let modalidad of listModalidad"
          class="modalidad-dropdown-item"
          [class.active]="modalidadCss(modalidad) === 'active'"
          (click)="selectModalidadAndBuy(modalidad)"
        >
          <div class="modalidad-info">
            <span class="modalidad-name">{{
              getTitleForModalidad(modalidad)
            }}</span>
            <span class="modalidad-price">{{
              getModalidadPrice(modalidad)
            }}</span>
          </div>
          <span class="modalidad-code">{{ modalidad }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
